import { AssignableType, Assignment, ClaimAssignableCanon } from '@eigtech/assignments-types'
import { getLog } from '@eigtech/ui-shared-logging'
import { corrupt } from 'exhaustive'

const log = getLog()

export function getJobAssignables<AssignableCanon extends AssignableType>(
  assignments: Assignment[] | undefined,
  assignableType: AssignableCanon
): GetJobAssignableReturn<AssignableCanon> | undefined {
  const assignable = assignments
    ?.map(({ assignable }) => assignable)
    ?.filter(
      (assignable): assignable is GetNarrowedAssignable<AssignableCanon> =>
        assignable.type === assignableType
    )

  switch (assignableType) {
    case 'claim':
      return assignable?.at(0)?.claim as GetJobAssignableReturn<AssignableCanon>
    case 'job':
      log.warn('jobs cannot be assigned to jobs')
      return undefined
    case 'vendorRates':
      log.warn('jobs cannot be assigned to vendor rates')
      return undefined

    default:
      corrupt(assignableType)
  }
}

// This should be easier if this issue is ever addressed
// https://github.com/microsoft/TypeScript/issues/33014
type GetJobAssignableReturn<TAssignable extends AssignableType> = TAssignable extends 'claim'
  ? ClaimAssignableCanon['claim']
  : never
type GetNarrowedAssignable<TAssignable extends AssignableType> = TAssignable extends 'claim'
  ? ClaimAssignableCanon
  : never

export const getJobClaim = (assignments: Assignment[] | undefined) =>
  getJobAssignables(assignments, 'claim')
